import React from 'react';
import {connect} from 'react-redux';
import {addShoppingCart, removeShoppingCart} from 'actions';
import {ShowIf} from 'components/utils';
import classNames from 'classnames';
import {toastr} from 'react-redux-toastr';

class ShoppingCartButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.saveCart = this.saveCart.bind(this);
    this.state = {
      isSave: false
    };
  }

  componentDidMount() {
    this.setState({isSave: this.props.shoppingCart.indexOf(this.props.productId) !== -1});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({isSave: nextProps.shoppingCart.indexOf(nextProps.productId) !== -1});
  }

  saveCart() {
    if (this.props.shoppingCart.indexOf(this.props.productId) === -1) {
      this.props.dispatch(addShoppingCart(this.props.productId));
      toastr.success('Thành công!', 'Đã thêm sản phẩm này vào giỏ hàng.');
    } else {
      this.props.dispatch(removeShoppingCart(this.props.productId));
      toastr.success('Thành công!', 'Đã xoá sản phẩm này khỏi giỏ hàng.');
    }
    this.setState({isSave: !this.state.isSave});
  }

  render() {
    return (
      <div className="cart-button">
        <ShowIf condition={this.state.isSave}>
          <button type="button" className={classNames({'button-red': this.props.isDetail, 'add-to-cart': !this.props.isDetail})} onClick={this.saveCart}>
            <span className="fa fa-minus"></span>
            {this.props.isDetail ? 'Xoá khỏi giỏ hàng' : 'Huỷ đơn hàng'}
          </button>
        </ShowIf>
        <ShowIf condition={!this.state.isSave}>
          <button type="button" className={classNames({'button-red': this.props.isDetail, 'add-to-cart': !this.props.isDetail})} onClick={this.saveCart}>
            <span className={classNames({'fa fa-plus': this.props.isDetail, 'fa fa-cart-plus': !this.props.isDetail})}></span>
            {this.props.isDetail ? 'Thêm vào giỏ hàng' : 'Đặt hàng'}
          </button>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart.items
});

export default connect(mapStateToProps)(ShoppingCartButton);



// WEBPACK FOOTER //
// ./components/partials/shopping-cart-button/shopping-cart-button.jsx